<template>
    <div class="card">
        <div class="card-header">{{t('Register')}}</div>
        <div class="card-body text-center" v-if="loading === true || loading === null">
            <loading/>
            <span class="d-block mt-2">{{t('Validating your account')}}</span>
        </div>
        <div class="card-body text-center" v-if="loading === false">
            <font-awesome-icon icon="times-circle" size="2x" class="text-danger"/>
            <br>
            <strong>{{t('Activation link is wrong')}}</strong>
            <br/>
            {{t('Please copy whole validation link from e-mail and try it again')}}
        </div>
    </div>
</template>
<script>
    import Loading from '../../core/Components/loading';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faTimesCircle} from '@fortawesome/free-solid-svg-icons'

    library.add(faTimesCircle);

    export default {
        components: {
            Loading,
        },
        created() {
            this.activate();
        },
        methods: {
            activate() {
                const data = {
                    userId: this.$route.params.userId,
                    hash: this.$route.params.hash,
                };
                this.$store.dispatch('account/activate', data).then(response => {
                    this.loading = true;
                    this.$store.dispatch('alert/success', 'Account was activated');
                    this.$router.push({
                        name: 'login'
                    });
                }).catch(error => {
                    this.loading = false;
                });
            },
        },
        data() {
            return {
                loading: null,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/public/Activate.vue